import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_email", data.email);
      toast.success("Login berhasil");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login gagal");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm border border-[color:var(--border)] p-8">
        <div className="text-[10px] tracking-widest text-neutral-500">ADMIN</div>
        <h1 className="display text-4xl mb-6">MASUK</h1>
        <label className="block text-[10px] tracking-widest text-neutral-500 mb-1">EMAIL</label>
        <input data-testid="admin-email" type="email" required className="w-full bg-transparent border border-[color:var(--border)] p-3 mb-4 focus:border-white outline-none" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <label className="block text-[10px] tracking-widest text-neutral-500 mb-1">KATA SANDI</label>
        <input data-testid="admin-password" type="password" required className="w-full bg-transparent border border-[color:var(--border)] p-3 mb-6 focus:border-white outline-none" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        <button data-testid="admin-login-btn" disabled={busy} className="w-full bg-white text-black py-3 text-xs tracking-widest">{busy ? "..." : "MASUK"}</button>
      </form>
    </div>
  );
}
